


import { Button } from "@progress/kendo-react-buttons";
import { useTranslation } from "react-i18next";

import Spinner from "../loader/ButtonSpinner";
import { ICON_BASE_PATH } from "@/app/utils/config";
import type { ReactNode } from "react";


interface GxBlackDownloadButtonProps {
  label?: string;
  onClick: () => void;
  loading?: boolean;
  disabled?: boolean;
  className?: string;
  children?: ReactNode;
  loadingLabel?: string;
}

const GxBlackDownloadButton: React.FC<GxBlackDownloadButtonProps> = ({
  onClick,
  label = "Apply",
  children,
  loading = false,
  disabled = false,
  loadingLabel,
}) => {
  const { t } = useTranslation();

  const handleClick = () => {
    if (!loading && !disabled) {
      onClick();
    }
  };

  const getButtonText = () => {
    if (loading) {
      return loadingLabel || children || "";
    }
    return children || "";
  };
  return (
    <Button
      onClick={handleClick}
      disabled={disabled || loading}
      className="gx-dialog-back-button-download gx-h4-eb"
    >
      {loading ? (
        <Spinner />
      ) : (
        <>
          <img
            src={`${ICON_BASE_PATH}download-icon.svg`}
            alt="toggle visibility"
            className="gx-viewinvoice-button-eye-img"
          />
        </>
      )}
      <span className="gx-p12-m">{getButtonText()}</span>
    </Button>
  );
};

export default GxBlackDownloadButton;
